import SlimSelect from 'slim-select'

if($('select')) {
    $('select').each(function (i, e) {
        new SlimSelect({
            select: e,
            showSearch: false
        })
    });
}

$(document).on('gform_post_render', function(){
    if($('select')) {
        $('select').each(function (i, e) {
            new SlimSelect({
                select: e,
                showSearch: false
            })
        });
    }
});
